export interface PageState {
  usermanagement: DefaultStates & {
    zerpaTableState?: ZerpaState;
  };
  institutemanagement: DefaultStates & {
    zerpaTableState?: ZerpaState;
  };
  trialmanagement: Omit<DefaultStates, 'filterValue'> & {
    zerpaTableState?: ZerpaState;
    year: string,
    type: number[],
    selectedTab: 'institute' | 'individual',
    showDeactivatedTrials: boolean,
  };
  enrollmentmanagement: DefaultStates & {
    selectedTab: 'institute' | 'individual',
  };
}

export type PageIdentifier = keyof PageState;

export type ZerpaState = {
  selectedRow?: unknown;
  orderBy?: string;
  order?: false | 'asc' | 'desc' | undefined;
  columnIsDate?: boolean;
  page?: number;
  rowsPerPage?: number;
}

type DefaultStates = {
  searchText: string;
  filterValue: string;
  selectedCheckboxIds: string[] | number[];
}

export const SET_PAGE_SELECTED_CHECKBOX_STATE = 'SET_PAGE_SELECTED_CHECKBOX_STATE';
export const SET_PAGE_SEARCH_TEXT = 'SET_PAGE_SEARCH_TEXT';
export const SET_PAGE_FILTER_VALUE = 'SET_PAGE_FILTER_VALUE';
export const SET_ZERPA_TABLE_STATE = 'SET_ZERPA_TABLE_STATE';
export const SET_PAGE_YEAR_VALUE = 'SET_PAGE_YEAR_VALUE';
export const SET_PAGE_TYPE_VALUE = 'SET_PAGE_TYPE_VALUE';
export const SET_PAGE_SELECTED_TAB = 'SET_PAGE_SELECTED_TAB ';
export const SET_PAGE_SHOW_DEACTIVATED = 'SET_PAGE_SHOW_DEACTIVATED';

type setZerpaSelectedCheckboxAction = {
  type: typeof SET_PAGE_SELECTED_CHECKBOX_STATE;
  pageId: PageIdentifier;
  payload: string[] | number[];
}

type setSearchTextAction = {
  type: typeof SET_PAGE_SEARCH_TEXT;
  pageId: PageIdentifier;
  payload: string;
}

type setFilterValueAction = {
  type: typeof SET_PAGE_FILTER_VALUE;
  pageId: PageIdentifier;
  payload: string;
}

type setZerpaTableState = {
  type: typeof SET_ZERPA_TABLE_STATE;
  pageId: PageIdentifier;
  payload: ZerpaState;
}

type setYearValueAction = {
  type: typeof SET_PAGE_YEAR_VALUE;
  pageId: PageIdentifier;
  payload: string;
}

type setYearPageAction = {
  type: typeof SET_PAGE_TYPE_VALUE;
  pageId: PageIdentifier;
  payload: number[];
}

type setPageSelectedTab = {
  type: typeof SET_PAGE_SELECTED_TAB;
  pageId: PageIdentifier;
  payload: 'institute' | 'individual';
}

type setPageShowDeactivated = {
  type: typeof SET_PAGE_SHOW_DEACTIVATED;
  pageId: PageIdentifier;
  payload: boolean;
}

export type PageStateActionTypes = setZerpaSelectedCheckboxAction
  | setSearchTextAction | setFilterValueAction | setZerpaTableState
  | setYearValueAction | setYearPageAction | setPageSelectedTab | setPageShowDeactivated;
